export default "__VITE_ASSET__28ae4164__"